// src/api/trainings.js
import api from "./axios";

// ---- helpers ----
// The admin create/update endpoints are multipart/form-data (they accept
// image/icon file uploads), so plain JS objects from react-hook-form need
// to be converted before being sent.
const toFormData = (data) => {
  const fd = new FormData();
  Object.entries(data || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (value instanceof File || value instanceof Blob) {
      fd.append(key, value);
    } else if (typeof value === "boolean") {
      fd.append(key, value ? "true" : "false");
    } else {
      fd.append(key, value);
    }
  });
  return fd;
};

// ---- Public ----
export const getPublicTrainings = (params) => api.get("/api/public/trainings/", { params });
export const getFeaturedTrainings = (params) => api.get("/api/public/trainings/featured/", { params });
export const getTrainingBySlug = (slug) => api.get(`/api/public/trainings/slug/${slug}/`);

// ---- Admin ----
export const adminGetTrainings = (params) => api.get("/api/admin/trainings/", { params });
export const adminGetTrainingById = (id) => api.get(`/api/admin/trainings/${id}/`);

// POST /api/admin/trainings/ expects multipart/form-data
export const adminCreateTraining = (data) =>
  api.post("/api/admin/trainings/", toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });

// PATCH /api/admin/trainings/{id}/ (partial update) — also multipart/form-data.
// Using PATCH here instead of PUT so the form doesn't have to resend every field.
export const adminUpdateTraining = (id, data) =>
  api.patch(`/api/admin/trainings/${id}/`, toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const adminDeleteTraining = (id) => api.delete(`/api/admin/trainings/${id}/`);

// The API has no dedicated /status/ or /order/ sub-routes — both are just
// partial updates against /api/admin/trainings/{id}/.
export const adminSetTrainingStatus = (id, isActive) =>
  api.patch(`/api/admin/trainings/${id}/`, toFormData({ isActive }), {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const adminSetTrainingOrder = (id, displayOrder) =>
  api.patch(`/api/admin/trainings/${id}/`, toFormData({ displayOrder }), {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const adminExportTrainings = () => api.get("/api/admin/trainings/export/", { responseType: "blob" });
export const adminDownloadTrainingTemplate = () => api.get("/api/admin/trainings/import-template/", { responseType: "blob" });
export const adminImportTrainings = (formData) =>
  api.post("/api/admin/trainings/import/", formData, { headers: { "Content-Type": "multipart/form-data" } });